import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, Typography } from '@mui/material';

const ClientSelector = ({ clients, selectedClient, onClientChange }) => {
  if (!clients || clients.length === 0) {
    return (
      <Box sx={{ p: 1 }}>
        <Typography variant="subtitle1">Nenhum cliente disponível</Typography>
      </Box>
    );
  }

  const handleChange = (event) => {
    const clientId = event.target.value;
    const client = clients.find(c => c._id === clientId);
    onClientChange(client);
  };

  return (
    <Box sx={{ minWidth: 200 }}>
      <FormControl fullWidth variant="outlined">
        <InputLabel id="client-select-label">Cliente</InputLabel>
        <Select
          labelId="client-select-label"
          id="client-select"
          value={selectedClient ? selectedClient._id : ''}
          onChange={handleChange}
          label="Cliente"
        >
          {clients.map((client) => (
            <MenuItem key={client._id} value={client._id}>
              {client.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ClientSelector;

